import { Component, OnInit } from '@angular/core';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import { ReportsEventService, ReportType } from '../reports-event.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-report-select',
    templateUrl: './report-select.component.html',
    styleUrls: ['./report-select.component.scss'],
    standalone: false
})
export class ReportSelectComponent implements OnInit {
    public types: DropdownMultiselectItem[] = [];

    public selectedType: ReportType = ReportType.Enrollment;

    constructor(private reportEvents: ReportsEventService, private translate: TranslateService) {}

    ngOnInit() {
        this.initReportTypes();
    }

    public onReportTypeChanged() {
        this.reportEvents.onTypeChange(this.selectedType);
    }

    private initReportTypes() {
        this.types.push(
            this.createDropdownItem(
                ReportType.Enrollment.toString(),
                ReportType.Enrollment,
                true,
                this.getTranslatedType(ReportType.Enrollment)
            )
        );
        this.types.push(
            this.createDropdownItem(
                ReportType.Capacity.toString(),
                ReportType.Capacity,
                false,
                this.getTranslatedType(ReportType.Capacity)
            )
        );
        this.types.push(
            this.createDropdownItem(
                ReportType.Transaction.toString(),
                ReportType.Transaction,
                false,
                this.getTranslatedType(ReportType.Transaction)
            )
        );
        this.selectedType = this.reportEvents.selectedType;
    }

    private createDropdownItem(id, value, isSelected: boolean = false, displayValue: string = null): DropdownMultiselectItem {
        return <DropdownMultiselectItem>{
            id: id,
            value: value,
            selected: isSelected,
            displayName: displayValue
        };
    }

    private getTranslatedType(type: ReportType) {
        return this.translate.instant('ReportType.' + ReportType[type]);
    }
}
